import { render, staticRenderFns } from "./menuAdmin.vue?vue&type=template&id=1048ecb6"
import script from "./menuAdmin.vue?vue&type=script&lang=js"
export * from "./menuAdmin.vue?vue&type=script&lang=js"
import style0 from "./menuAdmin.vue?vue&type=style&index=0&id=1048ecb6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports